
import React, { useMemo } from "react"
import {
    Paper,
    InputBase,
    Box,
    Typography,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Stack,
    Button,
    TextField,
    makeStyles,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import {
    RoomOccurenceType,
    RoomDurationDays,
    RoomDurationWeeks,
    RoomDurationMonth,
    filterString
} from "./Utils";
import moment from "moment";
import Grid from "@material-ui/core/Grid";

export const RenderRecurrenceType = (props) => {

    const { recurrence_type } = props

    let returnData = [];
    if (recurrence_type == RoomOccurenceType.DAILY) {
        for (let i = 1; i <= RoomDurationDays; i++) {
            returnData.push(<MenuItem key={i} value={i} sx={{ fontSize: 16 }}>{i}</MenuItem>)
        }
    } else if (recurrence_type == RoomOccurenceType.WEEKLY) {
        for (let i = 1; i <= RoomDurationWeeks; i++) {
            returnData.push(<MenuItem key={i} value={i} sx={{ fontSize: 16 }}>{i}</MenuItem>)
        }
    } else {
        for (let i = 1; i <= RoomDurationMonth; i++) {
            returnData.push(<MenuItem key={i} value={i} sx={{ fontSize: 16 }}>{i}</MenuItem>)
        }
    }

    return returnData;
}

export const RenderRecurrenceMDays = (props) => {

    let returnData = [];

    let days = moment().daysInMonth()

    for (let i = 1; i <= days; i++) {
        returnData.push(<MenuItem key={i} value={i} sx={{ fontSize: 16 }}>{i}</MenuItem>)
    }

    return returnData;
}

export const formatDate = (unixtime, format="YYYY-MM-DD hh:mm A") => <>{moment.unix(unixtime).locale('en').format(format)}</>

// format the ISO ("2023-01-05T06:16:02.262Z"") date to desired format
export const dateFormatter = (date=new Date(), format="YYYY-MM-DD hh:mm") => <>{moment(date).locale('en').format(format)}</>


export const DropDownOptions = (props) => {

    const {
        classes,
        handleChange,
        children,
        label,
        name,
        value,
        width = "100%"
    } = props;


    const onChange = (e) => {
        let {
            value,
            name
        } = e.target;

        console.log("value1111111 ", value, "name ", name)
        // handleChange(e)
    }

    if (props.noWrapper == undefined) {
        return (
            <Grid item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                className={classes.container}
            >
                {/* {props.helperContent != undefined ? props.helperContent : null} */}
                <FormControl
                    variant="filled"
                    className="payment-input"
                    sx={{
                        width: width,
                        fontSize: 16,
                        textAlign: "left",
                        marginBottom: "20px"
                    }}
                >

                    <InputLabel id={("select-" + classes.id)} sx={{ fontSize: 16 }}>
                        {label}
                    </InputLabel>
                    <Select
                        labelId={("select-" + classes.id)}
                        id={classes.id}
                        value={filterString(value || "")}
                        onChange={(e) => handleChange(e)}
                        name={name}
                        label={label}
                        sx={{ fontSize: 16 }}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                    >
                        {children}
                    </Select>
                </FormControl>
            </Grid>)
    } else {
        return (
            <FormControl
                variant="filled"
                className={" payment-input " + (classes.container)}
                sx={{
                    width: width,
                    fontSize: 16,
                    textAlign: "left",
                    marginBottom: "20px"
                }}
            >

                <InputLabel id={("select-" + classes.id)} sx={{ fontSize: 16 }}>
                    {label}
                </InputLabel>
                <Select
                    labelId={("select-" + classes.id)}
                    id={classes.id}
                    value={filterString(value || "")}
                    onChange={(e) => handleChange(e)}
                    name={name}
                    label={label}
                    sx={{ fontSize: 16 }}
                    MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                >
                    {children}
                </Select>
            </FormControl>
        )
    }


}

